var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("质量区块链")]),_c('el-input',{staticClass:"index",attrs:{"placeholder":"请输入标签上的追溯码"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}}),_c('el-button',{staticClass:"index butn",attrs:{"type":"primary"},on:{"click":_vm.handleConfirm}},[_vm._v("确认")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }